import React from "react";
import { Formik, FormikProps } from "formik";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { Person } from "@src/Interfaces/Entity/Person";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { ButtonsGrid, SSTFormTitleTypography } from "./styles";

interface IProps {
  currentPerson: Person;
  messageKey: string;
  onClose: () => void;
}

export default class PlainMessageForm extends React.Component<IProps> {
  render() {
    let title = Values.getLocalizationValue("handover");
    let description = Values.getLocalizationValue(this.props.messageKey);
    return (
      <Formik   
        initialValues={{}}
        onSubmit={this.props.onClose}
        render={(formikProps: FormikProps<any>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            <SSTFormTitleTypography>{title}</SSTFormTitleTypography>
            <Grid
              container
              spacing={16}
              justify="center"
              alignItems="center">
              <Grid item>{description}</Grid>
            </Grid>
            <ButtonsGrid container justify="center">
              <STButtonMargin onClick={this.props.onClose} variant="contained" color="primary">
                {Values.getLocalizationValue("close")}
              </STButtonMargin>
            </ButtonsGrid>
          </STFormWrapper>
        )}
      />
    );
  }
}
